import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { isEmpty } from 'lodash-es';
import { Dispatch, SetStateAction } from 'react';
import {
  updateUserStatus,
  IWorkspace,
  addToDisabledUsers,
  removeFromDisabledUsers,
} from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import { useNotificationStore } from '../../../utils/NotificationStore';

const StatusTypography = styled(Typography)(({ isDisabled }: { isDisabled: boolean }) => ({
  backgroundColor: isDisabled ? WsColors.Green100 : WsColors.Red100,
  color: isDisabled ? WsColors.Green500 : WsColors.Red500,
  padding: 4,
  width: '100%',
  borderRadius: 4,
  cursor: 'pointer',
  textAlign: 'center',
}));

const TotalInvitesListAdmin = ({
  invitedUsers,
  setInvitedUsers,
}: {
  invitedUsers: IWorkspace[];
  setInvitedUsers: Dispatch<SetStateAction<IWorkspace[]>>;
}) => {
  const data = invitedUsers.map((user) => ({
    email: user.userId,
    workspace: user.link,
    organization: user.organization,
    status: user.barred,
    isDisabledByAdmin: user.status == 'disabled',
  }));

  const setNotification = useNotificationStore((state) => state.setNotification);

  const handleChangeStatus = async (rowId: number) => {
    const tempInvitedUsers = [...invitedUsers];
    if (tempInvitedUsers[rowId]?.status === 'disabled') {
      try {
        await removeFromDisabledUsers(
          tempInvitedUsers[rowId]?.userId ?? '',
          tempInvitedUsers[rowId]?.id ?? ''
        );
        setInvitedUsers((prev) => {
          if (prev[rowId]?.status) prev[rowId].status = '';
          return [...prev];
        });
        setNotification({ type: 'success', message: 'User Enabled Successfully' });
      } catch (e) {
        setNotification({
          type: 'error',
          message: 'Something Went wrong try again after some time',
        });
      }
    } else {
      if (!isEmpty(tempInvitedUsers)) {
        try {
          tempInvitedUsers[rowId].workspaceUser.barred = true;
          tempInvitedUsers[rowId].barred = true;
          setInvitedUsers([...tempInvitedUsers]);
          await updateUserStatus(tempInvitedUsers[rowId]?.workspaceUser);
          await addToDisabledUsers(
            invitedUsers[rowId]?.userId ?? '',
            invitedUsers[rowId]?.id ?? ''
          );
          setInvitedUsers((prev) => {
            prev[rowId].status = 'disabled';
            return [...prev];
          });
          setNotification({ type: 'success', message: 'User Disabled Successfully' });
        } catch (e) {
          setNotification({
            type: 'error',
            message: 'Something Went wrong try again after some time',
          });
        }
      }
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ borderBottom: 'none' }} align="center">
              Email
            </TableCell>
            <TableCell sx={{ borderBottom: 'none' }} align="center">
              Workspace Name
            </TableCell>
            <TableCell sx={{ borderBottom: 'none' }} align="center">
              Organization Name
            </TableCell>
            <TableCell sx={{ borderBottom: 'none' }} align="center">
              Activate/Deactivate User
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((workspaceRow, index) => (
            <TableRow key={workspaceRow?.email} sx={{ border: 'none' }}>
              <TableCell sx={{ borderBottom: 'none' }} scope="row" align="center">
                {workspaceRow?.email}
              </TableCell>

              <TableCell sx={{ borderBottom: 'none' }} align="center">
                {workspaceRow?.workspace}
              </TableCell>

              <TableCell sx={{ borderBottom: 'none' }} align="center">
                {workspaceRow?.organization}
              </TableCell>
              <TableCell sx={{ borderBottom: 'none' }} align="center">
                <StatusTypography
                  onClick={() => handleChangeStatus(index)}
                  isDisabled={workspaceRow.isDisabledByAdmin}
                >
                  {workspaceRow.isDisabledByAdmin ? 'Enable' : 'Disable'}
                </StatusTypography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TotalInvitesListAdmin;
